import React, { useEffect, useState } from 'react';
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import {
    Container,
    Row,
    Col,
    Card,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown
} from 'reactstrap';
import Link from "next/link"
import styles from './styles.module.scss';
import NewsTag from "../../.sourceflow/news_tag.json";
import SearchIcon from '/public/site-assets/svg/black-magnifying-glass.svg';
import { useRouter } from 'next/router';

export default function AllBlogs({
    global,
    pathPrefix,
    customClass = "",
    post,
    pagePrefix = "blog/",
    tagName,
    ParentNews = false,
    locale,
    cardPagePrefix = "blog/",
    enableFilterBy = true,

    heading
}) {
    const router = useRouter();

    const [searchValue, setSearchValue] = useState('');
    const [filteredPosts, setFilteredPosts] = useState(post); // Initialize with all posts
    const [visiblePosts, setVisiblePosts] = useState(4); // Number of posts initially visible
    const [showMore, setShowMore] = useState(true);

    const handleSearchChange = (event) => {
        const newValue = event.target.value;
        setSearchValue(newValue);
        filterPosts(newValue);
    };

    const filterPosts = (keyword) => {
        const lowerCaseKeyword = keyword.toLowerCase();
        const filtered = post.filter((post) => {
            return (
                post.title?.toLowerCase().includes(lowerCaseKeyword) ||
                post.tag?.en?.toLowerCase().includes(lowerCaseKeyword)
            );
        });
        setFilteredPosts(filtered);
        setVisiblePosts(8); // Reset visible posts when filtering
    };

    const loadMore = () => {
        setVisiblePosts(visiblePosts + 4); // Increase the number of visible posts by 4
        if (visiblePosts + 4 >= filteredPosts.length) {
            setShowMore(false); // Disable the "Show More" button when there are no more posts to show
        }
    };

    useEffect(() => {
        // Initially, display the first 4 posts
        if (filteredPosts.length > 0) {
            setVisiblePosts(8);
            setShowMore(filteredPosts.length > 8);
        }

    }, [filteredPosts]);


    useEffect(() => {
        // Listen for route changes and reset the component's state
        setFilteredPosts(post); // Reset to the initial state when the route changes
        setVisiblePosts(8);
        setShowMore(filteredPosts.length > 8); // Set showMore based on initial state
    }, [router.asPath]); // Listen for route changes


    return (
        <section className={`${styles.root} ${customClass}`} >
            <Container>
                <div className="filters d-flex flex-wrap flex-md-nowrap justify-content-between mb-4">
                    <div className='mb-4 mb-lg-0'>
                        <h2>
                            <SourceFlowText global={global} path={`${pathPrefix}.heading`}>
                                {heading}
                            </SourceFlowText>
                        </h2>
                    </div>
                    <div>
                        {enableFilterBy ?
                            <div className={`d-flex align-items-center gap-4 flex-wrap`}>
                                <div className='d-flex flex-wrap align-items-center'>
                                    <label className='me-4'>Filter by</label>
                                    <UncontrolledDropdown>
                                        <DropdownToggle>{`${ParentNews ? "Show All" : tagName}`}</DropdownToggle>
                                        <DropdownMenu>
                                            {NewsTag?.category_values.map((post, index) => (
                                                <Link key={index} href={`/${locale ? locale : ""}${post.title.en === tagName ? "blog" : `${pagePrefix}${post.url_slug}`}`} passHref>
                                                    <DropdownItem key={index}>{`${post.title.en === tagName ? "Show All" : post.title.en}`}</DropdownItem>
                                                </Link>
                                            ))}
                                        </DropdownMenu>
                                    </UncontrolledDropdown>

                                </div>
                                <div className='position-relative search'>
                                    <input
                                        type="text"
                                        id="search"
                                        placeholder="Keyword search"
                                        onChange={handleSearchChange}
                                        value={searchValue}
                                    />
                                    <span className='search-icon d-inline-block position-absolute'>
                                        <SearchIcon />
                                    </span>
                                </div>
                            </div> : ""
                        }

                    </div>
                </div>

                <Row className="isotope-grid">
                    {filteredPosts.slice(0, visiblePosts).map((post, index) => (
                        <Col md={3} className={`item ${post?.tag?.en?.toLowerCase().replaceAll(",", "") ?? ''} mb-4`} key={index}>
                            <Card className="overflow-hidden h-100">
                                    <Link href={post?.external_campaign ? post.external_campaign : `/${locale ? locale : ""}${cardPagePrefix}${post.url_slug}/`} passHref>
                                        <a
                                            className="d-flex flex-wrap justify-content-between h-100"
                                            {...(post?.external_campaign ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                        <div className="position-relative">
                                            <SourceFlowImage
                                                src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                                size="800x500"
                                                alt={post?.title}
                                                className="card-img rounded-0"
                                            />
                                            {/* {post?.tag ?
                                                <div>
                                                    <span className="tertiary-bg text-black d-inline-block px-2 rounded-3 position-absolute post-tag"><small><strong>{post.tag.length <= 10 ? post.tag : post.tag.substring(0, 40) + "..."}</strong></small></span>
                                                </div> : null} */}
                                            {post?.tag?.length >= 1 && (
                                                <div className="position-absolute post-tag">
                                                    {post.tag?.map((post, index) => (
                                                        <span className="bg-white shadow text-black d-inline-block px-2 rounded-3 me-2 mb-2 text-nowrap" key={index}>
                                                            {post}
                                                        </span>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                        <div className="conteWrapper p-3">
                                            <div>
                                                <p className="post-title"><strong>{post?.title}</strong></p>
                                                {post?.short_description ?
                                                    <p className="post-description">{post.short_description}</p>
                                                    : ""}
                                                {post?.salary_package ?
                                                    <p className="post-salary">
                                                        {post?.salary_package}
                                                    </p>
                                                    : ""}
                                            </div>
                                            <span>
                                                Read More
                                            </span>
                                        </div>
                                    </a>
                                </Link>
                            </Card>
                        </Col>
                    ))}
                </Row>
                {showMore && (
                    <div className="text-center mt-4">
                        <button className="primaryBtn no-arrow border-0" onClick={loadMore}>Load more</button>
                    </div>
                )}
            </Container>
        </section>
    )

}

// links under links -- hmmm
// <Link href={`${pagePrefix}${post.url_slug}`}>
//     <a className="d-block h-100">
//         <Card className="overflow-hidden h-100">
//             <Link href={`/${locale ? locale : ""}${cardPagePrefix}${post.url_slug}/`}>
//                 <a className="d-flex flex-wrap justify-content-between h-100">
//                     <div className="position-relative">
//                         <SourceFlowImage
//                             src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
//                             size="800x500"
//                             alt={post?.title}
//                             className="card-img rounded-0"
//                         />
//                         {/* {post?.tag ?
//                             <div>
//                                 <span className="tertiary-bg text-black d-inline-block px-2 rounded-3 position-absolute post-tag"><small><strong>{post.tag.length <= 10 ? post.tag : post.tag.substring(0, 40) + "..."}</strong></small></span>
//                             </div> : null} */}
//                         {post?.tag?.length >= 1 && (
//                             <div className="position-absolute post-tag">
//                                 {post.tag?.map((post, index) => (
//                                     <span className="bg-white shadow text-black d-inline-block px-2 rounded-3 me-2 mb-2 text-nowrap" key={index}>
//                                         {post}
//                                     </span>
//                                 ))}
//                             </div>
//                         )}
//                     </div>
//                     <div className="conteWrapper p-3">
//                         <div>
//                             <p className="post-title"><strong>{post?.title}</strong></p>
//                             {post?.short_description ?
//                                 <p className="post-description">{post.short_description}</p>
//                                 : ""}
//                             {post?.salary_package ?
//                                 <p className="post-salary">
//                                     {post?.salary_package}
//                                 </p>
//                                 : ""}
//                         </div>
//                         <span>
//                             Read More
//                         </span>
//                     </div>
//                 </a>
//             </Link>
//         </Card>
//     </a>
// </Link>